module.exports = __webpack_public_path__ + "static/media/3 lion wolf blackwork tattoo legsleeve.1280x1748.4f75e40f.webp";